import { TRPCClientError } from '@trpc/client'

import type { AppRouter } from '@campai/server/routes'

import { toast } from '@/components/Toaster/constants'

export function isTRPCClientError(cause: unknown): cause is TRPCClientError<AppRouter> {
    return cause instanceof TRPCClientError
}

export function isTRPCClientAbortError(cause: unknown): cause is TRPCClientError<AppRouter> {
    return isTRPCClientError(cause) && ['ObservableAbortError', 'AbortError'].includes(cause.cause?.name || '')
}

export function handleTRPCClientError(error: unknown) {
    if (isTRPCClientError(error)) {
        toast.error(error.message)
    } else {
        throw error
    }
}

export { TRPCClientError }
